<template>
  <div>
    <v-card flat>
      <v-card-title v-if="title">{{ title }}</v-card-title>
      <div>
        <div class="caption" v-if="!oneFile">
          <i>Primary image</i> is the image that will displayed in search
          results and at the top of this item's listing. (It should not be a
          huge file).
        </div>
        <div class="caption">
          Click an image to review it - it will open it in a new tab.
        </div>
        <div v-if="!fileNameRoot" class="caption">
          Files can't be loaded until the item on this page is given a name.
        </div>
        <!-- <div
          class="d-flex flex-row flex-wrap justify-center justify-sm-start imageRow"
        > -->

        <v-simple-table class="ma-4">
          <tr>
            <th></th>
            <th>File</th>
            <th v-if="!oneFile">Primary</th>
            <th v-if="!oneFile">Type</th>
            <th v-if="!oneFile">Label</th>
            <th>Display?</th>
          </tr>
          <tr
            v-for="(file, i) in allFiles"
            :key="i"
            :class="{ rowDelete: file.display != '1' }"
          >
            <td>
              <a :href="`${$hostname}/${path}/${file.file}`" target="_blank">
                <img
                  v-if="file.fileType == 'image'"
                  :src="`${$hostname}/${path}/${file.file}`"
                  height="40"
                />
                <!--:class="file.display == 1 ? '' : 'removedImage'"
  -->

                <v-icon v-else-if="file.fileType == 'pdf'" large
                  >mdi-file-pdf-box</v-icon
                >
              </a>
            </td>
            <td>
              {{ file.file }}
              <div class="caption">({{ file.fileType }})</div>
            </td>
            <td v-if="!oneFile">
              <v-btn icon @click="changePrimary(i)">
                <v-icon color="green"
                  >mdi-radiobox-{{
                    allFiles[i].primaryImage == 1 ? "marked" : "blank"
                  }}</v-icon
                >
              </v-btn>
            </td>
            <td v-if="!oneFile">
              <v-select
                :items="contentTypeOptions"
                v-model="allFiles[i].contentType"
                outlined
                dense
                hide-details="auto"
              ></v-select>
            </td>
            <td v-if="!oneFile">
              <v-text-field
                v-model="allFiles[i].label"
                dense
                outlined
                hide-details="auto"
              ></v-text-field>
            </td>
            <td>
              <v-btn text small @click="toggleDisplay(i)" class="ma-2">
                <!-- :color="file.active ? 'red' : 'green'" -->
                <v-icon :color="file.display == '1' ? 'red' : 'gray'">
                  mdi-{{
                    file.display == "1" ? "delete" : "delete-restore"
                  }}</v-icon
                >
                {{ file.display == "1" ? "Delete" : "Restore" }}

                <!-- {{ file.active ? "Remove" : "Un-Remove" }} -->
              </v-btn>
            </td>
          </tr>
        </v-simple-table>
        <div v-if="limitReached">
          File limit is {{ limit }}. Remove a file to add a new one.
        </div>
        <div
          class="dropzone-container"
          @dragover.prevent="dragover"
          @dragleave.prevent="dragleave"
          @drop.prevent="drop"
          v-else
        >
          <input
            type="file"
            multiple
            name="file"
            id="fileInput"
            class="hidden-input"
            @change="onChange()"
            ref="file"
            :accept="accept"
          />

          <label for="fileInput" class="file-label">
            <div v-if="isDragging">Release to drop files here.</div>
            <div v-else>Drop file here or <u>click here</u> to upload.</div>
          </label>
        </div>
        <div v-if="loading > 0">LOADING!!</div>
        <!-- </div> -->
      </div>
    </v-card>
  </div>
</template>

<script>
// import Name from "../dir/file";
import axios from "axios";

export default {
  name: "MediaUploader",
  props: {
    dir: null, // the xxx in  '/images/xxx/', todo check for backslashes at beginning and end
    productId: null,
    previousFiles: {
      // an array of images that are already in the database for this concept
      type: Array,
      default: () => {
        return [];
      },
    },
    fileNameRoot: null, // files will be named this + date. If file exists the server will append "_1", "_2", etc
    accept: {
      type: String,
      default: "image/*", // ".pdf,.jpg,.jpeg,.png"
    },
    limit: {
      type: Number,
      default: 10,
    },
    oneFile: null, // true makes it just accept a file, without the "type" and "label" fields

    title: { type: String, default: "Media" },
  },
  data: function () {
    return {
      // files: [],
      // fileRecords: [],
      loading: 0,
      allFiles: [],
      isDragging: false,
      // filesToUpdate: [], // array if indices from allFiles
      // filesToAdd: [], // array if indices from allFiles
      contentTypeOptions: ["logo", "packaging", "design", "fitting", "insert"],
      meta: [],
    };
  },
  methods: {
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },

    remove(i) {
      this.files.splice(i, 1);
    },

    generateURL(file) {
      let fileSrc = URL.createObjectURL(file);
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc);
      }, 1000);
      return fileSrc;
    },

    dateString() {
      let today = new Date();
      var yyyy = today.getFullYear();
      var mm = today.getMonth() + 1; // getMonth() is zero-based
      var dd = today.getDate();
      return String(10000 * yyyy + 100 * mm + dd); // Leading zeros for mm and dd
    },
    onChange() {
      let fileList = this.$refs.file.files;
      Array.from(fileList).forEach((file) => {
        // console.log(file);
        this.fileAdded(file);
        // this.files.push(file);
      });

      // this.files = this.files.concat([...this.$refs.file.files]);
    },
    fileAdded(file) {
      // console.log(this.fileRecords);
      if (!this.fileNameRoot || !file) return;
      var formData = new FormData();
      //   var imagefile = this.fileRecords;
      formData.append("file", file);
      formData.append("path", this.path);
      formData.append("name", `${this.fileNameRoot}_${this.dateString()}`);
      let fileType = this.getType(file);
      this.loading++;
      // todo - download api endpoint
      axios
        .post(this.$hostname + "/fileUploader/simpleUploads.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          let d = response.data;
          // console.log(d);
          if (d.success && d.name) {
            // this.newFiles.push(d.name);

            this.allFiles.push({
              file: d.name,
              dir: this.dir,
              productId: this.productId,
              primaryImage: 0,
              display: 1,
              contentType: null,
              label: null,
              fileType: fileType,
              id: null,
            });
            // this.filesToAdd.push(this.allFiles.length - 1); // the index of the new file

            // this.newImages.push(this.data.images.length - 1); // save the index of all new images
          }
        })
        .finally(() => {
          this.loading--;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getType(file) {
      let rtn = null;
      if (file.type.includes("image")) rtn = "image";
      if (file.type.includes("pdf")) rtn = "pdf";
      return rtn;
    },
    toggleDisplay(i) {
      this.allFiles[i].display = this.allFiles[i].display == 0 ? 1 : 0;
    },
    emitFileList() {
      this.$emit("fileList", this.allFiles);
    },
    changePrimary(i) {
      this.allFiles.forEach((obj) => {
        obj.primaryImage = 0;
      });
      this.allFiles[i].primaryImage = 1;
    },
  },
  computed: {
    path: function () {
      return "/images/" + this.dir + "/";
    },
    activeFiles: function () {
      let files = [];
      this.allFiles.forEach((f) => {
        if (f.display) files.push(f);
      });
      return files;
    },
    filesRemaining: function () {
      return this.limit - this.activeFiles.length;
    },
    limitReached: function () {
      return this.filesRemaining < 1;
    },
  },
  watch: {
    allFiles: { handler: "emitFileList", deep: true },
  },

  mounted() {
    this.allFiles = JSON.parse(JSON.stringify(this.previousFiles));
    // if (this.oneFile) {
    //   this.limit = 1;
    // }
    // let i = 0;
    // this.previousFiles.forEach((file) => {
    //   this.allFiles.push(file);
    //   this.filesToUpdate.push(i);
    //   i++;
    // });
    // this.emitFileList();
  },
};
</script>

<style scoped>
.removedImage {
  opacity: 0.2;
}

/* new  */
/* .main {
  display: flex;
  flex-grow: 1;
  align-items: center;
  height: 100vh;
  justify-content: center;
  text-align: center;
} */

.dropzone-container {
  padding: 4rem;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 20px;
  display: block;
  cursor: pointer;
  text-align: center;
}
/* .disabled {
  opacity: 0.5;
} */

.preview-container {
  display: flex;
  margin-top: 2rem;
}

.preview-card {
  display: flex;
  border: 1px solid #a2a2a2;
  padding: 5px;
  margin-left: 5px;
}

.preview-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  border: 1px solid #a2a2a2;
  background-color: #a2a2a2;
}

tr.rowDelete {
  opacity: 0.5;
}
th {
  text-align: left;
}
td,
th {
  padding: 3px;
}
</style>
